import { render, staticRenderFns } from "./info-block.vue?vue&type=template&id=5e294b9c&"
import script from "./info-block.vue?vue&type=script&lang=ts&"
export * from "./info-block.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports